export default "__VITE_ASSET__8d899daa__"